<template>
  <el-date-picker style="width: 80%;" size="medium" v-model="selectDate" type="daterange" align="right" unlink-panels
    range-separator="-" start-placeholder="选择开始日期" end-placeholder="选择结束日期" value-format="yyyy-MM-dd"
    :picker-options="pickerOptions">
  </el-date-picker>
</template>

<script>
  export default {
    data() {
      return {
        selectDate: "",
        time: "1",
        pickerOptions: {
          shortcuts: [],
        },
      }
    },

    mounted() {
      this.getshortcuts()
    },

    methods: {

      getshortcuts() {
        if (this.time = "1") {
          this.pickerOptions.shortcuts = [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
          return
        }
        if (this.time = "2") {
          this.pickerOptions.shortcuts = [{

            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }, {
            text: '一月前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            }
          }, {
            text: '一年前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30 * 12);
              picker.$emit('pick', date);
            }
          }]
          return
        }

      }
    }


  }
</script>

<style>
</style>
